import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  visit({ params }) {
    Turbo.visit(params.url)
  }
}
